import { Accordion } from '../../../../../../components/general/accordion';
import MailIcon from '@mui/icons-material/Mail';
import { Grid } from '@mui/material';
import { PqrClosingProps } from '../props';
import { usePqrNotificationClose } from './hook';
import { Checkbox } from '../../../../../../components/general/fields/checkbox';

export const PqrNotificationClose = ({ closing }: PqrClosingProps) => {
    const { formik } = usePqrNotificationClose(closing);

    return (
        <Accordion
            title="NOTIFICACIÓN DFC"
            icon={<MailIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6} md={4}>
                    <Checkbox
                        label="Enviar Email Cierre"
                        checked={Boolean(formik.values.emailNotification)}
                        isCheckMode
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
